import { ResponseModel } from "../../models/response_model";
import configApi from "../api/config_api";

const configService = {
  getConfigs: async (): Promise<ResponseModel> => {
    try {
     const res = await configApi.getConfigs();
     return res.data;
    } catch (error) {
      console.error("configService.getConfigs():", error);
      throw error;
    }
  },
};
export default configService;
